import React from 'react';
import Dropzone from 'react-dropzone'
import ReactGA from 'react-ga';
import { connect } from 'react-redux'
import { fetchEvent, editWinners } from '../../actions'
import { uploadArtifact } from './eventUtils/eventUploadUtils'
import { uploadTypes } from '../helpers/AppConsts'
import { GA_TRACKING_UPLOAD_WINNERS_PAGE } from '../helpers/AppConsts'

class EventWinners extends React.Component {
  componentDidMount(){
    ReactGA.ga('send', 'pageview', GA_TRACKING_UPLOAD_WINNERS_PAGE);
    this.props.fetchEvent(this.props.match.params.eventId, this.props.match.params.event_organizer);
  }
  
   renderEvent() {
    return  (
              <div className="content">
                <div className="header"><b>Event_ID:</b> {this.props.edits.editEvent.event_id}</div>
                <div className="header"><b>Event_Name:</b> {this.props.edits.editEvent.event_name}</div>
                <div className="header"><b>Event_location:</b> {this.props.edits.editEvent.event_location}</div>
             </div>
            )
  }

  onDrop = (files) =>{
    uploadArtifact(files, this.props.edits.editEvent, this.props.editWinners, uploadTypes.WINNERS_UPLOAD)
  }

  render () {
    if(!this.props.edits.editEvent){
      return (
        <div className="ui container">
          <h2>Upload Winners Image</h2>
          Loading..          
        </div>
      );
    }
    return (
      <div className="ui container">
        <h2>Upload Game Winners</h2>
        {this.renderEvent()}

        <Dropzone onDrop={this.onDrop}>  
            {({getRootProps, getInputProps}) => (
              <div {...getRootProps({className: 'dropzone'})}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop game image here, or click to select files
                <img alt="placeholder" src="/images/wireframe/white-image.png" className="ui medium image" />
                </p>
              </div>
            )}
        </Dropzone>       
      </div>
    );
    }
};

const mapStateToProps = (state, ownProps) => {
  return {
    edits: state.edits,
    currentUserEmail: state.auth.userEmail
  };
}
export default connect(mapStateToProps, {fetchEvent,editWinners})(EventWinners)

